// extracted by mini-css-extract-plugin
export default {"profile":"style_profile__cL0ld","big":"style_big__z-flA"};